import { Button, Col, Modal, Row } from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import { useHistory, withRouter } from 'react-router-dom';
import { ReactComponent as DownloadCtx } from '../../../../assets/images/svg/DownloadCtx.svg';
import DownloadCtxModal from './DownloadCtxModal';
import ReconcileNowModal from './ReconcileNowModal';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../store';
import { ReconciliationState } from '../../../../store/models/reconciliationModel';
import { centeredNotification } from '../../../../utils/utility';
import { GLOBAL_URL } from '../../../../shared/constants/dataServiceUrl';
import ApplicationDetail from '../../../../shared/services/applicationDetail.service';
import { ReactComponent as RoundTickIcon } from '../../../../assets/images/svg/i_round_tick.svg';
import { GUTTOR_SPACE } from '../../../../shared/constants/commonConstants';
import TableConfigurator from '../../../../shared/components/TableConfigurator/TableConfigurator';
import { getReconciliationTableMapping } from '../../../../shared/constants/reconciliationConstants';
import { ApplicationDetailModel } from '../../../../store/models/applicationDetailModel';
import { FormInstance } from 'antd/lib/form';
import { saveInPatientConfig } from '../../../../store/actions/inPatientAction';
import moment from 'moment';

const ReconcilationHeader = (props: any): ReactElement => {
  const { viewId, lastStatusUpdated } = useSelector((state: RootState): ReconciliationState => state?.reconciliation || {});
  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);
  const [isReconcileNowModalOpen, setIsReconcileNowModalOpen ] = useState(false);
  const [isUploadSuccessfulModalOpen, setIsUploadSuccessfulModalOpen] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [FormattedLastStatusUpdatedDate, setFormattedLastStatusUpdatedDate] = useState('');
  const [fileListObj, setFileListObj] = useState({}) as any;
  const reconciliationTableMapping = getReconciliationTableMapping();

  const appDetail = ApplicationDetail.instance;
  const appDetailModel: ApplicationDetailModel = useSelector((state: RootState): ApplicationDetailModel => state?.applicationDetail || {});
  const groupProviders = ApplicationDetail.instance.getGroupProviders();

  const dispatch = useDispatch();
  const history = useHistory();
  const onDownloadModalCancel = (): any => {
    setIsDownloadModalOpen(false);
  };
  const onReconcileNowModalClose = (): any => {
    setIsReconcileNowModalOpen(false);
  };

  useEffect((): any => {
    setFormattedLastStatusUpdatedDate(lastStatusUpdated ? moment(lastStatusUpdated).format('L') + ' '
    + moment(lastStatusUpdated).format('LTS') : '');
  }, [lastStatusUpdated]);

  const uploadFiles = async (): Promise<any> => {
    setIsUploading(true);
    const formData = new FormData();
        formData.append('FileType', 'FinanceReport');
        formData.append('File', fileListObj['FinanceReport'] ? fileListObj['FinanceReport'][0]['originFileObj'] : null);
        formData.append('ProviderId', appDetail.getProviderId());
    fetch(`${GLOBAL_URL.CRM_BASE_URL}Reconciliation/AddReconciliation`, {
            method: 'POST',
            body: formData,
         })
         .then((response: any): any => response.json())
         .then((response: any): any => {
          setIsUploading(false);
          if (response.isSuccess) {
            setIsReconcileNowModalOpen(false);
            setFileListObj([]);
            setIsUploadSuccessfulModalOpen(true);
          } else {
            centeredNotification(response.errors.join(',\n'));
          }
         })
         .catch((err: any): any => centeredNotification(err));
    return null;
  };
  const cancelUpload = (): any => {
    setFileListObj([]);
    setIsReconcileNowModalOpen(false);
  };
  const onColumnEditSave = (form: FormInstance, setIsVisible: any): any => {
    dispatch(saveInPatientConfig(form.getFieldsValue(), setIsVisible, 'reconciliation'));
  };

  return (
    <React.Fragment>
        {
          viewId === 3 &&
          <Row className="header-main-div" justify="end">
            <Col className="flex-element flex-col item-center justify-center" xs={24} sm={12} md={12} lg={6}>
              <div className="flex-element p-sm reconciliation-status bold item-center">
                Last Status Updated: {FormattedLastStatusUpdatedDate}
              </div>
            </Col>
            <Col className="header-components">
              <DownloadCtx className="mouse-pointer" onClick={(): any => {setIsDownloadModalOpen(true); }}/>
            </Col>
          </Row>
        }
        {
          viewId !== 3 &&
          <Row className="header-main-div" justify="end">
          <Col className="header-components">
            <Button className="ghost-primary-btn" disabled={groupProviders?.length > 0} type="ghost" onClick={(): any => { history.push('/reconciliation/reconciliation-new/tds-configure');
              }}>
              TDS Configuration
            </Button>
          </Col>
          <Col className="header-components">
            <Button className="btn" type="primary" onClick={(): any => {setIsReconcileNowModalOpen(true); }}>
              Reconcile Now
            </Button>
          </Col>
          <Col className="header-components">
            <DownloadCtx className="mouse-pointer" onClick={(): any => {setIsDownloadModalOpen(true); }}/>
          </Col>
          <Col className="header-components header-table-config">
            <TableConfigurator
              tableMapping={reconciliationTableMapping}
              saveClickHandler={onColumnEditSave}
              configuration={appDetailModel.getReconciliationIPConfig()} />
          </Col>
        </Row>
        }
      {isDownloadModalOpen &&
        <Modal
          visible={isDownloadModalOpen}
          title="Download Report"
          footer={null}
          onCancel={onDownloadModalCancel}
        >
          <DownloadCtxModal/>
        </Modal>
      }
      {isReconcileNowModalOpen &&
        <Modal
        visible={isReconcileNowModalOpen}
        okText={'Upload'}
        okType="primary"
        onOk={uploadFiles}
        onCancel={cancelUpload}
        afterClose={onReconcileNowModalClose}
        destroyOnClose={false}
        confirmLoading={isUploading}>
          <ReconcileNowModal fileListObj={fileListObj} setFileListObj={setFileListObj}/>
        </Modal>
      }
      {
        isUploadSuccessfulModalOpen &&
        <Modal
        visible={isUploadSuccessfulModalOpen}
        footer={
          <Row className="w-100 flex flex-element flex-col items-center">
            <Col md={12} className="w-100 flex flex-element flex-col items-center">
              <Button type="primary" onClick={(): any => setIsUploadSuccessfulModalOpen(false)}>Close</Button>
            </Col>
          </Row>
        }
        onCancel={(): any => setIsUploadSuccessfulModalOpen(false)}>
          <Row gutter={GUTTOR_SPACE} justify="center" className="mb-sm">
            <strong><RoundTickIcon className="fill-success" /></strong>
          </Row>
          <Row gutter={GUTTOR_SPACE} justify="center" className="mb-sm">
            <strong className="text-success">Files Uploaded Succesfully</strong>
          </Row>
          <Row gutter={GUTTOR_SPACE} justify="center" className="flex flex-element items-center mb-sm">
            <div className="flex flex-element items-center text-center mb-sm">Reconciling your claims.
            Notification will be sent to the hospital's
            configured mailbox. (It might take up-to 120 mins)</div>
          </Row>
        </Modal>
      }
    </React.Fragment>
  );
};

export default withRouter(ReconcilationHeader);
